import { useAppSelector } from "../../common/redux/hooks";

export const useBasicSourcingEventState = () => {
  const eventState = useAppSelector((state) => state.basicSourcingEvent.state);
  if (!eventState) throw Error("No event state.");
  return eventState;
};
